import type { BlogArticleResult } from 'hooks/siteSearch/types';
import { BLOG } from 'lib/constants/routes';

import { ResultLayout } from '../layouts/ResultLayout';
import type { NavigationPayload } from '../SearchResults';

interface BlogArticleProps extends BlogArticleResult {
  onNavigate: ({ title, path }: NavigationPayload) => void;
}

export function BlogArticle({
  title,
  slug,
  image,
  onNavigate,
}: BlogArticleProps) {
  const path = `${BLOG}/${slug}`;

  return (
    <ResultLayout
      href={path}
      title={title}
      image={image}
      type="Article"
      onNavigate={() => onNavigate({ title, path })}
    />
  );
}
